<template>
  <div>
    <Header />
    <main>
      <div class="checkout-stages">
        <Stage1
            v-if="currentStage === 1"
            :formData="formData"
            @updateForm="updateForm"
            @next="nextStage"
        />

        <Stage2
            v-if="currentStage === 2"
            :formData="formData"
            @updateForm="updateForm"
            @next="nextStage"
            @back="prevStage"
        />

        <Stage3
            v-if="currentStage === 3"
            :formData="formData"
            @updateForm="updateForm"
            @next="nextStage"
            @back="prevStage"
        />
      </div>

    </main>
  </div>
</template>

<script>
import Header from '../Header/Header.vue'
import Stage1 from './DeliveryStage.vue'
import BillStage from './BillStage.vue'
import PaymentStage from './PaymentStage.vue'

export default {
  name: 'Checkout',
  components: {
    Header,
    Stage1,
    Stage2: PaymentStage,
    Stage3: BillStage,
  },
  data() {
    return {
      currentStage: 1,
      formData: {
        email: '',
        discord: '',
        discount: '',
        paymentMethod: '',
        tip: null
      }
    }
  },
  methods: {
    nextStage() {
      if (this.currentStage < 3) this.currentStage++
    },
    prevStage() {
      if (this.currentStage > 1) this.currentStage--
    },
    updateForm(newData) {
      this.formData = {
        ...this.formData,
        ...newData
      };
    }
  },
  metaInfo() {
    return {
      title: "Checkout | ShopT"
    }
  }
}
</script>

<style scoped>
main {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  width: 100%;
}

.checkout-stages {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
